<script>
import { mapGetters } from 'vuex';
import { Howl } from 'howler';
import InfoButton from 'ne01-common/src/components/InfoButton';
import CountUp from '../components/CountUp';

export default {
  name: 'EndPage',
  components: {
    InfoButton,
    CountUp
  },
  data: () => {
    return {
      audio: null,
    }
  },
  mounted() {
    this.audio = new Howl({
      src: [this.feedback],
      autoplay: true,
    });
  },
  methods: {
    unloadStation() {
      this.$emit('unloadStation');
    }
  },
  computed: {
    ...mapGetters({
      infoPage: 'getEndScreenInfoPageId',
      statisticsTotals: 'getStatisticsTotals',
      feedbacks: 'getFeedbackVoiceovers',
    }),
    feedback() {
      if (this.statisticsTotals.normalized.score < 0.25)
        return this.feedbacks[0];
      else if (this.statisticsTotals.normalized.score >= 0.25 
                && this.statisticsTotals.normalized.score < 0.5 )
        return this.feedbacks[1];
      else if (this.statisticsTotals.normalized.score >= 0.5 
                && this.statisticsTotals.normalized.score < 0.9 )
        return this.feedbacks[2];
      else
        return this.feedbacks[3];
    }
  },
  beforeDestroy() {
    this.audio.pause();
  },
}
</script>

<template>
  <div class="end-page">
    <div class="end-page__content">
      <p class="end-page__score">
        <count-up v-bind:value="statisticsTotals.correct" />
      </p>
      <p class="end-page__score-label">{{$t('end.label1')}}</p>
      <p class="end-page__score">
        <count-up v-bind:value="statisticsTotals.wrong" />
      </p>
      <p class="end-page__score-label">{{$t('end.label2')}}</p>

      <info-button class="end-page__info" v-bind:id="infoPage" />
    </div>

    <div class="end-page__actions">
      <button class="common-button" v-on:click="unloadStation()">{{$t('end.unload')}}</button>
    </div>

  </div>
</template>

<style scoped lang="scss">
@import '../assets/styles/variables';
@import '../assets/styles/common';

.end-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
}

.end-page__content {
  padding: 4rem 0;
}

.end-page__score {
  font-size: 6.25rem;
  font-family: var(--font-family-primary);
  margin: 0;

  text-align: center;
  line-height: .6;
}

.end-page__score-label {
  font-family: var(--font-family-secondary);
  font-size: 2rem;
  margin-bottom: 4rem;
  text-align: center;
}

.end-page__info {
  margin-top: 9rem;
}
</style>
